import { render, staticRenderFns } from "./MarkdownInput.vue?vue&type=template&id=53f7d771&lang=pug&"
import script from "./MarkdownInput.vue?vue&type=script&lang=js&"
export * from "./MarkdownInput.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports